import { IGetter } from "./IGetter";
import { Func1 } from "redux";

const toPath = require('lodash/toPath');
const get = require('lodash/get');


export function getPath(selector: (x?: any) => any, skip = 0): string[] {
    const stringPath = getPathString(selector);
    const path = toPath(stringPath);
    return skip < 1 ? path : path.slice(skip);
}

export function getFrom<TSrc, TProp>(src: TSrc, from: (x: TSrc) => TProp, def?: TProp): TProp {
    return get(src, getPath(from, 1), def);
}

export function buildGetterFrom<TSrc, TProp = any>(from: Func1<TSrc, TProp>, def?: TProp): IGetter<TSrc, TProp> {
    const [stringPath, path] = splitPath(from);
    return buildGetter(stringPath, path, def);
}

function splitPath<TSrc, TProp>(from: Func1<TSrc, TProp>): [string, string[]] {
    const stringPath = getPathString(from);
    const path = toPath(stringPath);

    return [
        stringPath.replace(new RegExp(path[0] + '\\.?'), ''),
        path.slice(1)
    ]
}

function buildGetter<TSrc, TProp = any>(stringPath: string, path: string[], def: TProp): IGetter<TSrc, TProp> {
    return {
        getFrom: (s: TSrc) => get(s, path, def),
        getPath: () => stringPath,
        getPaths: () => path,
        addSelector<TSub>(subSelector: Func1<TProp, TSub>, def?: TSub): IGetter<TSrc, TSub> {
            const [subStringPath, subPath] = splitPath(subSelector);
            const prefix = subStringPath.startsWith('[') ? '' : '.';
            return buildGetter<TSrc, TSub>(stringPath + prefix + subStringPath, path.concat(subPath), def);
        },
        addPath<TSub>(subPath: string[], def?: TSub): IGetter<TSrc, TSub> {
            return buildGetter<TSrc, TSub>(
                stringPath + '.' + subPath.join('.'),
                path.concat(subPath),
                def);
        }
    };
}


const extractPath = /return (([A-Za-z0-9_.]|(\[".+?"\])|(\['.+?'\])|(\[\d+\]))+)[;} ]/;

function getPathString(selector: (x?: any) => any): string {
    const e = extractPath.exec(selector + '');
    if (e == null)
        throw new Error("The function does not contain a statement matching '() => variableName'");
    return e[1];
}